import React from 'react';
import Login from '../../../components/layout/login/Login';

const LoginPage = () => {
  return (
    <div>
      <Login />
    </div>
  );
};

export default LoginPage;
